import { App, View } from "@pimo/pimo-app-builder";
import { DragAndDropLayout, PMDonutChartCard } from "@pimo/pimo-components";
import { getLocalizedMessage } from "@pimo/pimo-l10n";

import { TestAppState } from "../../../app";

export function addCompletionByMaturityCards(
  view: View<TestAppState, DragAndDropLayout>,
  app: App<TestAppState>
) {
  const language = app.getAppState().language || "en";
  const orderedMaturityLevels = (
    app.getAppState().settings?.configuration?.maturityConfiguration ?? []
  )
    .slice()
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
    .filter((entry) => Boolean(entry.name));

  orderedMaturityLevels.forEach((maturityEntry, index) => {
    const maturityName = maturityEntry.name ?? "";
    const componentId = `reportCompletionByMaturity-${index}-${maturityName
      .toLowerCase()
      .replace(/\s+/g, "-")}`;

    const completionByMaturityCard = view.addComponent({
      component: PMDonutChartCard,
      layoutProps: {
        componentId,
        labels: ["donutChart", "chart", "completion", "maturity"],
        title:
          getLocalizedMessage(language, "cards.completionByMaturity.title", {
            maturityName,
          }) || `Completion of Maturity - ${maturityName}`,
        description:
          getLocalizedMessage(
            language,
            "cards.completionByMaturity.description",
            { maturityName }
          ) ||
          "Distribution of completion degrees for activities in this maturity",
      },
    });

    completionByMaturityCard.mapState(
      ({ currentReport, settings, language }) => {
        const items = currentReport?.project?.reportingItems ?? [];
        const maturityItems = items.filter(
          (item) => (item.basicItem?.maturity ?? "") === maturityName
        );

        const completionDefinitions = (
          settings?.configuration?.degreeOfCompletionDefinition ?? []
        )
          .slice()
          .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

        const data = completionDefinitions.map((entry) => ({
          label: entry.name ?? "",
          value: maturityItems.filter(
            (item) => (item.degreeOfCompletion ?? "") === (entry.name ?? "")
          ).length,
          color: entry.color ?? "",
        }));

        return {
          title:
            getLocalizedMessage(language, "cards.completionByMaturity.title", {
              maturityName,
            }) || `Completion of Maturity - ${maturityName}`,
          description:
            getLocalizedMessage(
              language,
              "cards.completionByMaturity.description",
              { maturityName }
            ) ||
            "Distribution of completion degrees for activities in this maturity",
          showInfoIcon: false,
          showMenuIcon: false,
          data,
        };
      }
    );

    completionByMaturityCard.mapVisibility(({ settings }) => {
      return settings?.configuration?.useCase === "maturity";
    });
  });
}
